// web/src/components/signature-pad.tsx
import { forwardRef, useImperativeHandle, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

export interface SignaturePadHandle {
  toBase64Png(): string | null;
  clear(): void;
  isEmpty(): boolean;
}

export interface SignaturePadProps {
  width?: number;
  height?: number;
}

export const SignaturePad = forwardRef<SignaturePadHandle, SignaturePadProps>(function SignaturePad(
  { width = 480, height = 160 }: SignaturePadProps,
  ref
) {
  const sig = useRef<SignatureCanvas>(null);
  useImperativeHandle(ref, () => ({
    toBase64Png: () => {
      const canvas = sig.current?.getCanvas();
      if (!canvas || sig.current!.isEmpty()) return null;
      // Strip the "data:image/png;base64," prefix.
      return canvas.toDataURL("image/png").split(",")[1] ?? null;
    },
    clear: () => sig.current?.clear(),
    isEmpty: () => sig.current?.isEmpty() ?? true,
  }));
  return (
    <div className="border rounded-md inline-block bg-white">
      <SignatureCanvas ref={sig} canvasProps={{ width, height, className: "block" }} />
    </div>
  );
});
